import React, { useState } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';

import { dmarcPassTypeOptions } from './dmarc-pass-type-options';
import MenuItem from 'fuse-ui/components/MenuItem';
import Menu from 'fuse-ui/components/Menu';
import Chip from 'fuse-ui/components/Chip';
import { withStyles } from '@material-ui/core/styles';
import opacity from '../../../common/theme/colors/opacity';

const styles = theme => ( {
    chip: {
        'float': 'right',
        marginRight: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit * 2,
    },
    chipPrint: {
        '@media print': {
            display: 'inline-flex',
            'float': 'right',
            marginRight: theme.spacing.unit * 2,
            marginTop: theme.spacing.unit * 2,
        },
        display: 'none',
    },
    focus: {
        '&:focus': {
            backgroundColor: opacity.primary08
        },
        backgroundColor: opacity.primary08,
    },
    menu: {
        width: 175
    },
    option: {
        '&:focus': {
            backgroundColor: opacity.primary08
        }
    },
} );

const DmarcSelector = ( { classes, handleDmarcPassTypeChange, selectedDmarcPassType, automationId } ) => {
    const [anchorEl, setAnchorEl] = useState( null );

    function handleClick( event ){
        setAnchorEl( event.currentTarget );
    }

    function handleClose(){
        setAnchorEl( null );
    }

    function handleMenuClick( option ){
        handleDmarcPassTypeChange( option.key );
        setAnchorEl( null );
    }

    return (
        <React.Fragment>
            <Chip
                className={classes.chipPrint}
                label={find( dmarcPassTypeOptions, { key: selectedDmarcPassType } ).display}
                size="small"
            />
            <Chip
                className={`${classes.chip} no-print`}
                clickable={true}
                label={find( dmarcPassTypeOptions, { key: selectedDmarcPassType } ).display}
                onClick={handleClick}
                onDropDown={() => {}}
                selected={Boolean( anchorEl )}
                data-automation-id={automationId}
                size="small"
            />
            <Menu
                className={classes.menu}
                anchorEl={anchorEl}
                open={Boolean( anchorEl )}
                onClose={handleClose}>
                {
                    dmarcPassTypeOptions.map( ( option ) => {
                        const formattedOption = option.display.toLowerCase().split( ' ' ).join( '-' );
                        return (
                            <MenuItem
                                classes={{
                                    root: classes.option,
                                    selected: classes.focus
                                }}
                                onClick={() => handleMenuClick( option )}
                                key={option.key}
                                value={option.key}
                                data-automation-id={formattedOption}>
                                {option.display}
                            </MenuItem>
                        );
                    } )
                }
            </Menu>
        </React.Fragment>
    );
};

DmarcSelector.propTypes = {
    automationId: PropTypes.string.isRequired,
    classes: PropTypes.object,
    handleDmarcPassTypeChange: PropTypes.func.isRequired,
    selectedDmarcPassType: PropTypes.string.isRequired,
};

export default withStyles( styles )( DmarcSelector );
